__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => (typeof console !== "undefined" && console.warn && console.warn(msg));
	var uniqueName = "@openmrs/esm-patient-clinical-view-app";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@openmrs/esm-framework", "3.1.15-pre.861", () => (__webpack_require__.e(339).then(() => (() => (__webpack_require__(6339))))));
			register("@openmrs/esm-patient-common-lib", "3.1.0", () => (Promise.all([__webpack_require__.e(501), __webpack_require__.e(171), __webpack_require__.e(279), __webpack_require__.e(612), __webpack_require__.e(403), __webpack_require__.e(906), __webpack_require__.e(482), __webpack_require__.e(35)]).then(() => (() => (__webpack_require__(8482))))));
			register("carbon-components", "10.40.0", () => (__webpack_require__.e(635).then(() => (() => (__webpack_require__(9635))))));
			register("carbon-icons", "7.0.7", () => (__webpack_require__.e(402).then(() => (() => (__webpack_require__(5402))))));
			register("react-i18next", "11.15.3", () => (Promise.all([__webpack_require__.e(403), __webpack_require__.e(932)]).then(() => (() => (__webpack_require__(9932))))));
			register("react", "16.14.0", () => (__webpack_require__.e(784).then(() => (() => (__webpack_require__(2784))))));
			register("rxjs", "6.6.7", () => (__webpack_require__.e(206).then(() => (() => (__webpack_require__(5206))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};